"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalDetails = exports.howDidYouHearAboutUs = exports.crmInUseOther = exports.crmInUse = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var CensusCollector_1 = require("../CensusCollector");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Fields_1 = require("Common/Form/Fields");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var inversify_react_1 = require("inversify-react");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var react_transition_group_1 = require("react-transition-group");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var utils_1 = require("@qwilr/kaleidoscope/utils");
var Types_1 = require("@CommonFrontendBackend/Onboarding/Types");
var ValidateStrings_1 = require("@CommonFrontendBackend/Utils/ValidateStrings");
var event_tracker_types_1 = require("@qwilr/event-tracker-types");
var Types_2 = require("User/Types");
var CensusCollectorStore_1 = __importDefault(require("../CensusCollectorStore"));
var SpheresBackgroundManager_1 = require("Onboarding/CensusCollector/SpheresBackground/SpheresBackgroundManager");
var OnboardingTypes_1 = require("Onboarding/OnboardingTypes");
var OnboardingTelemetryService_1 = __importDefault(require("Onboarding/OnboardingTelemetryService"));
var Environment_1 = require("@CommonFrontendBackend/Environment");
var extractNames = require("@CommonFrontendBackend/Utils/ExtractNames");
var c = (0, BemBuilder_1.default)("personal-details-form");
var crmOptions = [
    {
        id: Types_1.CrmOptionId.Salesforce,
        name: "Salesforce",
    },
    {
        id: Types_1.CrmOptionId.Hubspot,
        name: "HubSpot",
    },
    {
        id: Types_1.CrmOptionId.Pipedrive,
        name: "Pipedrive",
    },
    {
        id: Types_1.CrmOptionId.Zoho,
        name: "Zoho CRM",
    },
    {
        id: Types_1.CrmOptionId.CustomBuilt,
        name: "Custom-built CRM",
    },
    {
        id: Types_1.CrmOptionId.None,
        name: "None",
    },
    {
        id: Types_1.CrmOptionId.Other,
        name: "Other",
        isOtherOption: true,
    },
];
exports.crmInUse = {
    id: "crm-used",
    type: kaleidoscope_1.FormType.Dropdown,
    props: {
        label: "Which CRM do you use?",
        placeholder: "Select an option",
    },
    options: crmOptions,
    showOtherTextInput: true,
    otherTextInputProps: {
        label: "Please enter which CRM you're using",
        placeholder: "Please enter which CRM you're using",
    },
    validate: function (value) {
        if (value.length === 0) {
            return "Please select CRM used, or select None if you don't use one";
        }
    },
};
exports.crmInUseOther = {
    id: "crm-used-other",
    type: kaleidoscope_1.FormType.Text,
    props: {
        label: "What is your CRM?",
        placeholder: "Enter your CRM",
    },
    validate: function (value) {
        if (!value) {
            return "Please enter your CRM";
        }
    },
};
exports.howDidYouHearAboutUs = {
    id: "how-did-you-hear-about-us",
    type: kaleidoscope_1.FormType.Text,
    props: {
        label: "How did you hear about us?",
        placeholder: "e.g. Google, HubSpot Marketplace, etc.",
    },
    validate: function (value) {
        var validationResult = (0, ValidateStrings_1.checkBasicText)(value);
        if (validationResult.valid === false) {
            return "This field ".concat(validationResult.error);
        }
    },
};
var PersonalDetails = (function (_super) {
    __extends(PersonalDetails, _super);
    function PersonalDetails() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.fields = [];
        _this.getFields = function () {
            var fieldList = [];
            if ((0, lodash_1.isNil)(_this.user.firstName)) {
                var nameField = (0, lodash_1.cloneDeep)(Fields_1.Name);
                nameField.props.label = "What's your name?";
                fieldList.push(nameField);
            }
            if (!_this.user.hasSetPassword) {
                fieldList.push(Fields_1.Password);
            }
            if (_this.userListLength === 1) {
                fieldList.push(Fields_1.CompanyName, Fields_1.OptionGroupSalesTeamSize, exports.crmInUse, exports.howDidYouHearAboutUs);
            }
            return fieldList;
        };
        _this.submitForm = function (values) { return __awaiter(_this, void 0, Promise, function () {
            var responses, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        responses = (0, lodash_1.mapValues)(values, function (value) { return "".concat(value); });
                        this.dataStore.update(responses);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.onComplete(responses)];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        err_1 = _a.sent();
                        return [2, (0, kaleidoscope_2.createFormSubmitErrorObject)("We're having trouble submitting your response. Please try again later.")];
                    case 4: return [2];
                }
            });
        }); };
        _this.fieldExists = function (id) {
            var field = _this.fields.find(function (field) { return field.id === id; });
            return !!field;
        };
        _this.isFirstField = function (id) {
            return _this.fields.findIndex(function (field) { return field.id === id; }) === 0;
        };
        _this.renderForm = function () {
            _this.fields = _this.getFields();
            return (react_1.default.createElement(kaleidoscope_2.FormComponent, { className: c("form"), fieldSize: "large", onSubmit: _this.submitForm },
                react_1.default.createElement(kaleidoscope_2.FormContext.Consumer, null, function (context) {
                    var _a, _b;
                    if (!context) {
                        throw new Error("FormContext must be inside a FormComponent");
                    }
                    var submitError = context.submitError, values = context.values, form = context.form;
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        _this.fieldExists(Fields_1.Name.id) && (react_1.default.createElement(FormV2FieldTransition, { className: c("field") },
                            react_1.default.createElement(kaleidoscope_2.FormTextInput, { name: Fields_1.Name.id, label: "What's your name?", placeholder: "My name", autoFocus: _this.isFirstField(Fields_1.Name.id), validate: function (value) {
                                    if (!value) {
                                        return "Please enter your name";
                                    }
                                    var validationResult = (0, ValidateStrings_1.checkBasicText)(value);
                                    if (validationResult.valid === false) {
                                        return "A name ".concat(validationResult.error);
                                    }
                                }, onChange: function () { return _this.spheresBackgroundManager.triggerPulse(1.5); }, initialValue: (_a = _this.dataStore.getById(Fields_1.Name.id)) !== null && _a !== void 0 ? _a : "" }))),
                        _this.fieldExists(Fields_1.Password.id) && (react_1.default.createElement(FormV2FieldTransition, { className: c("field") },
                            react_1.default.createElement(kaleidoscope_2.FormTextInput, { name: Fields_1.Password.id, type: kaleidoscope_1.TextInputType.Password, label: "Password", placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022", validate: Fields_1.Password.validate, autoFocus: _this.isFirstField(Fields_1.Password.id), onChange: function () { return _this.spheresBackgroundManager.triggerPulse(1.5); }, initialValue: "" }))),
                        _this.fieldExists(Fields_1.CompanyName.id) && (react_1.default.createElement(FormV2FieldTransition, { className: c("field") },
                            react_1.default.createElement(kaleidoscope_2.FormTextInput, { name: Fields_1.CompanyName.id, label: "What's your company name?", placeholder: "Acme Corp", autoFocus: _this.isFirstField(Fields_1.CompanyName.id), validate: function (value) {
                                    if (!value) {
                                        return "Please enter your company name";
                                    }
                                    var validationResult = (0, ValidateStrings_1.checkBasicText)(value);
                                    if (validationResult.valid === false) {
                                        return "A company name ".concat(validationResult.error);
                                    }
                                }, onChange: function () { return _this.spheresBackgroundManager.triggerPulse(1.5); }, initialValue: _this.dataStore.getById(Fields_1.CompanyName.id) || _this.dataStore.brandDetailsName || "", onClick: function (event) {
                                    if (event.detail === 2) {
                                        _this.onAutofill(form);
                                    }
                                } }))),
                        _this.fieldExists(Fields_1.OptionGroupSalesTeamSize.id) && (react_1.default.createElement(FormV2FieldTransition, { className: c("field") },
                            react_1.default.createElement(kaleidoscope_2.FormSegmentedControl, { name: Fields_1.OptionGroupSalesTeamSize.id, label: "How big is your sales team?", onChange: function () { return _this.spheresBackgroundManager.triggerPulse(2.5); }, options: Fields_1.OptionGroupSalesTeamSize.props.options, initialValue: (_b = _this.dataStore.getById(Fields_1.OptionGroupSalesTeamSize.id)) !== null && _b !== void 0 ? _b : "0", validate: function (value) {
                                    var allowedValues = Fields_1.OptionGroupSalesTeamSize.props.options.map(function (o) { return o.value; });
                                    if (!allowedValues.includes(value)) {
                                        return "Please select an option";
                                    }
                                } }))),
                        _this.fieldExists(exports.crmInUse.id) && (react_1.default.createElement(FormV2FieldTransition, { className: c("field") },
                            react_1.default.createElement(kaleidoscope_1.Layer, { offset: 890 }, function () {
                                return (react_1.default.createElement(kaleidoscope_2.FormSelect, { name: exports.crmInUse.id, label: "Which CRM do you use?", placeholder: "Select an option", initialValue: _this.dataStore.getById(exports.crmInUse.id), autoStack: true, onClick: function () { return _this.spheresBackgroundManager.triggerPulse(2); }, validate: function (value) {
                                        if (!value) {
                                            return "Please select CRM used, or select None if you don't use one";
                                        }
                                    } }, crmOptions.map(function (option) { return (react_1.default.createElement(kaleidoscope_1.SelectOption, { value: option.id, key: option.id, onClick: function () { return _this.spheresBackgroundManager.triggerPulse(3); } }, option.name)); })));
                            }))),
                        react_1.default.createElement(FormV2FieldTransition, { className: c("field") },
                            react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(kaleidoscope_1.Expandable, { onEnter: utils_1.forceReflow, expanded: !!values[exports.crmInUse.id] && values[exports.crmInUse.id] === "other", className: (0, classnames_1.default)(c("field"), c("field", "reduced-gap"), c("field", "expandable")) }, function (_a) {
                                    var expandableElementRef = _a.expandableElementRef;
                                    return (react_1.default.createElement("div", { ref: expandableElementRef },
                                        react_1.default.createElement(kaleidoscope_2.FormTextInput, { name: exports.crmInUseOther.id, label: exports.crmInUseOther.props.label, labelHidden: true, placeholder: exports.crmInUseOther.props.placeholder, autoFocus: true, onChange: function () { return _this.spheresBackgroundManager.triggerPulse(3); }, validate: exports.crmInUseOther.validate, initialValue: _this.dataStore.getById(exports.crmInUseOther.id) })));
                                }))),
                        _this.fieldExists(exports.howDidYouHearAboutUs.id) && (react_1.default.createElement(FormV2FieldTransition, { className: c("field") },
                            react_1.default.createElement(kaleidoscope_2.FormTextInput, { name: exports.howDidYouHearAboutUs.id, label: exports.howDidYouHearAboutUs.props.label, placeholder: exports.howDidYouHearAboutUs.props.placeholder, initialValue: _this.dataStore.getById(exports.howDidYouHearAboutUs.id), onChange: function () { return _this.spheresBackgroundManager.triggerPulse(2); }, validate: exports.howDidYouHearAboutUs.validate }))),
                        react_1.default.createElement(FormV2FieldTransition, { className: c("button-wrapper") },
                            react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(kaleidoscope_1.Expandable, { onEnter: utils_1.forceReflow, expanded: !!submitError }, function (_a) {
                                    var expandableElementRef = _a.expandableElementRef;
                                    return (react_1.default.createElement("div", { ref: expandableElementRef },
                                        react_1.default.createElement(kaleidoscope_1.Alert, { heading: "Error", alertType: kaleidoscope_1.AlertType.Error }, submitError)));
                                }),
                                react_1.default.createElement(kaleidoscope_2.FormSubmitButton, { className: c("button") },
                                    react_1.default.createElement("span", null, "Continue"))))));
                })));
        };
        _this.onComplete = function (values) { return __awaiter(_this, void 0, Promise, function () {
            var setters, names, crmValues, telemetryProperties;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setters = [];
                        if (values[Fields_1.Name.id]) {
                            names = extractNames(values[Fields_1.Name.id]);
                            this.apiService.setUsername(names.firstName, names.lastName);
                        }
                        if (this.userListLength === 1) {
                            crmValues = {
                                crmTechnology: values[exports.crmInUse.id],
                                crmTechnologyOther: values[exports.crmInUse.id] === Types_1.CrmOptionId.Other && values[exports.crmInUseOther.id] ? values[exports.crmInUseOther.id] : undefined,
                            };
                            setters.push(this.apiService.setAccountDetails(__assign({ name: values[Fields_1.CompanyName.id], salesTeamSize: values[Fields_1.OptionGroupSalesTeamSize.id], howDidYouHearAboutUs: values[exports.howDidYouHearAboutUs.id] }, crmValues)));
                            setters.push(this.apiService.updateAccountCensus({
                                crmTechnology: values[exports.crmInUse.id],
                            }));
                            setters.push(this.apiService.updateUserCensus({
                                howDidYouHearAboutUs: values[exports.howDidYouHearAboutUs.id],
                            }));
                            telemetryProperties = {
                                salesTeamSize: parseInt(values[Fields_1.OptionGroupSalesTeamSize.id]),
                                crmTechnology: crmValues.crmTechnology,
                                crmTechnologyOther: crmValues.crmTechnologyOther,
                            };
                            this.onboardingTelemetryService.onboardingStepCompleted(event_tracker_types_1.OnboardingStepName.PersonalDetails, telemetryProperties);
                        }
                        else {
                            this.onboardingTelemetryService.onboardingStepCompleted(event_tracker_types_1.OnboardingStepName.PersonalDetails);
                        }
                        if (!this.user.hasSetPassword) {
                            setters.push(this.apiService.setPassword(values[Fields_1.Password.id]));
                        }
                        return [4, Promise.all(setters)];
                    case 1:
                        _a.sent();
                        this.props.onComplete();
                        return [2];
                }
            });
        }); };
        _this.onAutofill = function (form) {
            var environment = QwilrConfig.environment;
            if ((0, Environment_1.isNonProductionEnvironment)(environment || Environment_1.Environment.Production)) {
                if (_this.fieldExists(Fields_1.Name.id) && !form.getState().values[Fields_1.Name.id]) {
                    form.change(Fields_1.Name.id, (0, utils_1.randomString)(10));
                }
                if (_this.fieldExists(Fields_1.Password.id) && !form.getState().values[Fields_1.Password.id]) {
                    form.change(Fields_1.Password.id, "".concat((0, utils_1.randomString)(10), "-@12A"));
                }
                if (_this.fieldExists(Fields_1.CompanyName.id) && !form.getState().values[Fields_1.CompanyName.id]) {
                    form.change(Fields_1.CompanyName.id, (0, utils_1.randomString)(10));
                }
                if (_this.fieldExists(Fields_1.OptionGroupSalesTeamSize.id) && !form.getState().values[Fields_1.OptionGroupSalesTeamSize.id]) {
                    form.change(Fields_1.OptionGroupSalesTeamSize.id, "1");
                }
                if (_this.fieldExists(exports.crmInUse.id) && !form.getState().values[exports.crmInUse.id]) {
                    form.change(exports.crmInUse.id, crmOptions[0]);
                }
            }
        };
        return _this;
    }
    PersonalDetails.prototype.render = function () {
        if (this.props.config.integrationOnboardingName)
            this.dataStore.setById(exports.crmInUse.id, this.props.config.integrationOnboardingName);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(CensusCollector_1.className, "__personal-details"), "".concat(CensusCollector_1.className, "__personal-details--shrink")) },
                react_1.default.createElement(react_transition_group_1.CSSTransition, { in: true, timeout: 1100, appear: true, classNames: "".concat(CensusCollector_1.className, "__header-transition") },
                    react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(CensusCollector_1.className, "__header"), "".concat(CensusCollector_1.className, "__header--extra-wide")) },
                        react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", strong: true, align: "center" }, "Tell us a bit about yourself"),
                        this.userListLength === 1 && (react_1.default.createElement(kaleidoscope_1.Text, { size: "l", align: "center" }, "We'll use this to tailor the experience to your needs")))),
                this.renderForm())));
    };
    var _a, _b, _c, _d, _e;
    __decorate([
        (0, inversify_react_1.resolve)("user"),
        __metadata("design:type", typeof (_a = typeof Types_2.IUserInAccount !== "undefined" && Types_2.IUserInAccount) === "function" ? _a : Object)
    ], PersonalDetails.prototype, "user", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("userListLength"),
        __metadata("design:type", Number)
    ], PersonalDetails.prototype, "userListLength", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("censusCollectorStore"),
        __metadata("design:type", typeof (_b = typeof CensusCollectorStore_1.default !== "undefined" && CensusCollectorStore_1.default) === "function" ? _b : Object)
    ], PersonalDetails.prototype, "dataStore", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("spheresBackgroundManager"),
        __metadata("design:type", typeof (_c = typeof SpheresBackgroundManager_1.SpheresBackgroundManager !== "undefined" && SpheresBackgroundManager_1.SpheresBackgroundManager) === "function" ? _c : Object)
    ], PersonalDetails.prototype, "spheresBackgroundManager", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("apiService"),
        __metadata("design:type", typeof (_d = typeof OnboardingTypes_1.IApiService !== "undefined" && OnboardingTypes_1.IApiService) === "function" ? _d : Object)
    ], PersonalDetails.prototype, "apiService", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("onboardingTelemetryService"),
        __metadata("design:type", typeof (_e = typeof OnboardingTelemetryService_1.default !== "undefined" && OnboardingTelemetryService_1.default) === "function" ? _e : Object)
    ], PersonalDetails.prototype, "onboardingTelemetryService", void 0);
    PersonalDetails = __decorate([
        mobx_react_1.observer
    ], PersonalDetails);
    return PersonalDetails;
}(react_1.default.Component));
exports.PersonalDetails = PersonalDetails;
var FormV2FieldTransition = function (_a) {
    var className = _a.className, children = _a.children;
    return (react_1.default.createElement(react_transition_group_1.CSSTransition, { in: true, appear: true, enter: false, exit: false, timeout: 1700, classNames: c("field-transition") },
        react_1.default.createElement("div", { className: className }, children)));
};
